import {
  PartialSheetViews, SheetViews,
  Sheets,
  UnSavedSheetsChanges
} from '../../../types';
// import { updateDependentSheetViewports } from '../rootDeprecated/root';

export interface ResetSheetsWithChangesResult {
  updatedSheets: Sheets;
  sheetsToRemoveFromMem: string[];
  updatedSheetViews: PartialSheetViews;
  // updatedGroups: SheetGroups;
  // groupsToRemoveFromMem: string[];
}
export function* resetSheetsWithChanges(
  sheets: Sheets,
  unSavedChanges: UnSavedSheetsChanges
) {
  const sheetsToRemoveFromMem: string[] = [];
  const sheetsToRecompile: string[] = [];

  for (const changes of unSavedChanges.sheetRoot) {
    for (const { op, path } of changes) {
      if (op === 'add') {
        const sheetId = path[0].toString();
        if (!sheetsToRemoveFromMem.includes(sheetId) && sheets[sheetId])
          sheetsToRemoveFromMem.push(sheetId);
      }
    }
  }

  Object.keys(unSavedChanges.sheets).forEach((sheetId) => {
    if (!sheetsToRecompile.includes(sheetId) && sheets[sheetId])
      sheetsToRecompile.push(sheetId);
  });

  const updatedSheets: Sheets = {};

  for (let sheetId of sheetsToRecompile) {
    if (!sheetsToRemoveFromMem.includes(sheetId)) {
      // If sheet is not part of removed sheets then and only then recompile it
      // const sheet: SnapshotResult<Sheet> = yield startReadSheet(
      //   sheetId,
      //   false,
      //   true
      // );
      // if (sheet.data && !sheet.dataLost) updatedSheets[sheetId] = sheet.data;
    }
  }
  const updatedSheetViews: SheetViews = {};
  // yield updateDependentSheetViewports('', updatedSheets, updatedSheetViews);

  return {
    updatedSheets,
    updatedSheetViews,
    sheetsToRemoveFromMem,
  };
}

// export interface ApplySheetsWithChangesResult {
//   updatedSheets: Sheets;
//   updatedGroups: SheetGroups;
// }
// export async function applySheetsWithChanges(
//   userId: string,
//   primaryStorage: PrimaryStorage,
//   // sheetGroups: SheetGroups,
//   unSavedChanges: SheetHistory[]
// ): Promise<ApplySheetsWithChangesResult> {
//   let updatedGroups: SheetGroups = {}; //sheetGroups;
//   let updatedSheets: Sheets = {};

//   for (const { sheets, groups } of unSavedChanges) {
//     if (sheets) {
//       for (let sheetId in sheets) {
//         const changes = sheets[sheetId];
//         if (!updatedSheets[sheetId]) {
//           const sheet = await readSheet(primaryStorage, sheetId);

//           if (!sheet.dataLost && sheet.data) {
//             updatedSheets[sheetId] = sheet.data as Sheet;
//           }
//         }

//         if (updatedSheets[sheetId]) {
//           updatedSheets[sheetId] = applyPatches(
//             updatedSheets[sheetId],
//             changes
//           );
//         }
//       }
//     }

//     if (groups) {
//       for (let change of groups) {
//         const { op, path } = change;
//         const groupId = path[0].toString();
//         if (op === 'add' || op === 'replace') {
//           const group = await readGroup(userId, primaryStorage, groupId);
//           if (!group.dataLost && group.data) {
//             updatedGroups[groupId] = group.data;
//           }
//         }
//       }
//       updatedGroups = applyPatches(updatedGroups, groups);
//     }
//   }

//   return {
//     updatedGroups,
//     updatedSheets,
//   };
// }
